// 初始化宝藏状态
const totalTreasures = 5;
let foundTreasures = JSON.parse(localStorage.getItem("foundTreasures") || "[]");

// 使用事件委托处理宝藏点击
document.addEventListener('click', function(e) {
    // 处理宝藏图标点击
    const treasureIcon = e.target.closest('.treasure-icon');
    if (treasureIcon) {
        const id = treasureIcon.getAttribute("data-id");

        // 如果没找到过这个宝藏
        if (!foundTreasures.includes(id)) {
            foundTreasures.push(id);
            localStorage.setItem("foundTreasures", JSON.stringify(foundTreasures));
        }

        // 更新弹窗内容
        const msg = document.getElementById("treasure-message");
        if (!msg) return;
        
        if (foundTreasures.length < totalTreasures) {
            msg.innerHTML = `<center><img src="https://cdn.shopify.com/s/files/1/0331/6042/9701/files/Treasure-box.webp?v=1755253813" alt="" width="30%" style="max-width:150px" height="auto" class="treasure-popup-bg"></center><br>Treasure #${foundTreasures.length} is yours -  ${totalTreasures - foundTreasures.length} more to go. <br>Keep hunting… the pirates are starting to panic! 🏴‍☠️`;
        } else {
            msg.innerHTML = `<br><br><h3>Whoa… you actually found them ALL!</h3><br>
You've outsmarted the pirates, raided every chest, and left nothing behind.<br><br>
Your reward? <span>30% OFF</span> with code <span>Treasure30</span> — already applied when you click.<br><br><br>
<center><a href="/discount/Treasure30" class="button">Claim My 30% OFF</a></center>
<ul><li>Limit 1 per customer</li><li>No custom or sale items</li></ul><br>`;
        }
    }
});